<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-29 10:49:35
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-20 14:50:30
-->
<template>
	<el-tabs v-model="curPlatform" @tab-click="handleClick">
		<el-tab-pane :name="`${item.value}`" :label="item.label" v-for="item in platformList" :key="item.value">
			<slot :platform_id="item.value" v-if="+item.value === +curPlatform"></slot>
		</el-tab-pane>
	</el-tabs>
</template>
<script>
import { PLATFORM_ALL } from '@/utils/dataMap';
import { mapGetters } from 'vuex';
export default {
	name: 'PlatformTab',
	props: {
		platformId: {
			type: [String, Number],
			default: 1,
		},
		showAll: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			curPlatform: `${this.platformId}`,
		};
	},
	computed: {
		...mapGetters(['platformVersion', 'canShowPlatformList']),
		platformList() {
			return this.showAll ? [{ ...PLATFORM_ALL, label: '全部' }, ...this.canShowPlatformList] : this.canShowPlatformList;
		},
	},
	methods: {
		handleClick({ name }) {
			this.curPlatform = name;
			this.$emit('change', +name);
		},
	},
};
</script>